'use strict';
// ==================
//  MVスライダー
// ==================
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.splide-fv').forEach((el) => {
    new Splide(el, {
      type: 'loop',
      arrows: false,
      autoplay: true,
      speed: 2000,
      interval: 4000,
      pauseOnHover: false,
      pauseOnFocus: false,
      pagination: false,
    }).mount();
  });

  document.querySelectorAll('.splide-sp').forEach((el) => {
    new Splide(el, {
      autoplay: true,
      type: 'loop',
      pauseOnHover: false,
      pauseOnFocus: false,
      pagination: false,
      interval: 5000,
      speed: 2000,
      padding: '13.5%',
      gap: 24,
      destroy: true,
      breakpoints: {
        749: { destroy: false },
      },
    }).mount();
  });
});

//================
// ドロワーメニュー
//================
document.addEventListener("DOMContentLoaded", () => {
  setUpAccordion();
  changeAccordion();
});

/**
 * ブラウザの標準機能(Web Animations API)を使ってアコーディオンのアニメーションを制御します
 */
const setUpAccordion = () => {
  const details = document.querySelectorAll(".js-details");
  const RUNNING_VALUE = "running"; // アニメーション実行中のときに付与する予定のカスタムデータ属性の値
  const IS_OPENED_CLASS = "is-opened"; // アイコン操作用のクラス名

  details.forEach((element) => {
    const summary = element.querySelector(".js-summary");
    const content = element.querySelector(".js-content");

    summary.addEventListener("click", (event) => {
      // デフォルトの挙動を無効化
      event.preventDefault();

      // 連打防止用。アニメーション中だったらクリックイベントを受け付けないでリターンする
      if (element.dataset.animStatus === RUNNING_VALUE) {
        return;
      }
      let icon = element.children[0];
      icon.classList.toggle(IS_OPENED_CLASS);
      // detailsのopen属性を判定
      if (element.open) {
        // アコーディオンを閉じるときの処理
        // アイコン操作用クラスを切り替える(クラスを取り除く)
        element.classList.toggle(IS_OPENED_CLASS);
        // アニメーションを実行
        const closingAnim = content.animate(closingAnimKeyframes(content), animTiming);
        // アニメーション実行中用の値を付与
        element.dataset.animStatus = RUNNING_VALUE;

        // アニメーションの完了後に
        closingAnim.onfinish = () => {
          // open属性を取り除く
          element.removeAttribute("open");
          // アニメーション実行中用の値を取り除く
          element.dataset.animStatus = "";
        };
      } else {
        // アコーディオンを開くときの処理
        // open属性を付与
        element.setAttribute("open", "true");

        // アイコン操作用クラスを切り替える(クラスを付与)
        element.classList.toggle(IS_OPENED_CLASS);
        // アニメーションを実行
        const openingAnim = content.animate(openingAnimKeyframes(content), animTiming);
        // アニメーション実行中用の値を入れる
        element.dataset.animStatus = RUNNING_VALUE;
        openingAnim.onfinish = () => {
          element.dataset.animStatus = "";
        };
      }
    });
  });
}

/**
 * アニメーションの時間とイージング
 */
const animTiming = {
  duration: 400,
  easing: "ease-out"
};

/**
 * アコーディオンを閉じるときのキーフレーム
 */
const closingAnimKeyframes = (content) => [
  {
    height: content.offsetHeight + 'px', // height: "auto"だとうまく計算されないため要素の高さを指定する
    opacity: 1,
  }, {
    height: 0,
    opacity: 0,
  }
];

/**
 * アコーディオンを開くときのキーフレーム
 */
const openingAnimKeyframes = (content) => [
  {
    height: 0,
    opacity: 0,
  }, {
    height: content.offsetHeight + 'px',
    opacity: 1,
  }
];

/**
 * ハンバーガーボタンを押したら＋をーに
 */
const changeAccordion = () => {
  const hamburgerDetails = document.querySelectorAll(".js-hamburger");
  const accordion = document.querySelectorAll(".js-summary");
  hamburgerDetails.forEach((element) => {
    const hamburgerSummary = element.querySelector(".js-hamburgerSummary");
    hamburgerSummary.addEventListener("click", (event) => {
      console.log(element.open);
      if (element.open) {
        accordion.forEach((element) => {
          element.classList.remove("is-opened");
        });
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function () {
  // mh-newnav__itemクラスを持つ要素を取得
  var customItems = document.querySelectorAll('.mh-newnav__item');

  // 各要素に対してイベントリスナーを追加
  customItems.forEach(function (item) {
    item.addEventListener('click', function (event) {
      setTimeout(function () {
        var customContainer = document.getElementById('Details-menu-drawer-container');
        var menuButton = document.querySelector('.header__icon--menu');
        var bodyElement = document.body;
        menuButton.setAttribute('aria-expanded', 'false');
        customContainer.classList.remove('menu-opening');
        bodyElement.classList.remove('overflow-hidden-tablet');
      }, 500);
    });
  });
});

//================
// 年齢認証
//================
document.addEventListener('DOMContentLoaded', function () {
  document.body.style.display = 'block';
});

$(document).ready(function () {
  $(".js-yes").on('click', function () {
    $(".mh-certification").fadeOut(300);
  });
  //ボタンがクリックされたときの処理
  $(".js-yes").on("click", function () {
    // クッキーにクリックがあったことを保存（有効期限は3日間）
    $.cookie('buttonClicked', 'true', { expires: 3, path: '/' });
  });

  // ページ読み込み時にクッキーをチェックし、クリックされた場合の処理を実行
  if ($.cookie('buttonClicked') === 'true') {
    // ここにクリックされた場合の処理を記述
    $(".mh-certification").remove();
  }
  $(".js-no").on('click', function () {
    let newElement = '<p class="mh-certification__no-read">未成年者へのお酒の販売は法律で禁じられています。<br>ご理解とご協力をお願いいたします。<br>またのご来店を心よりお待ちしています。</p>' + '<a href="./" class="mh-certification__btn mh-certification__btn--back">認証ページに戻る<span>back</span></a>';
    $(".mh-certification__btns").remove();
    $(".mh-certification__text").remove();

    // "mh-certification__ttl"クラスの次にHTMLを追加
    $(".mh-certification__ttl").after(newElement);
  });
});


//================
// スムーススクロール
//================
$(document).on('click', 'a[href*="#"]', function () {
  let time = 500;
  let header = $('header').innerHeight();
  let target = $(this.hash);
  if (!target.length) return;
  let targetY = target.offset().top - header;
  $('html,body').animate({ scrollTop: targetY }, time, 'swing');
  return false;
});

//================
// チェックボックスの要素とボタンの要素を取得
//================
var agreeCheckbox = document.getElementById('agree');
var submitButton = document.getElementById('submitBtn');

// チェックボックスの状態が変更されたときのイベントリスナーを追加
if (submitButton && agreeCheckbox) {
  agreeCheckbox.addEventListener('change', function () {
    // チェックボックスがチェックされているかどうかを確認
    if (agreeCheckbox.checked) {
      // チェックがついたらボタンのdisabled属性を削除
      submitButton.removeAttribute('disabled');
    } else {
      // チェックが外れたらボタンのdisabled属性を追加
      submitButton.setAttribute('disabled', 'disabled');
    }
  });
}

// ==================
//  オンラインストアスライダー
// ==================
var slider = document.getElementById('slider');
if (slider) {
  document.addEventListener('DOMContentLoaded', function () {
    new Splide('.splide', {
      autoplay: true, // 自動再生
      type: "loop", // ループ
      pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      arrows: false,
      pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
      interval: 6000, // 自動再生の間隔
      speed: 4000, // スライダーの移動時間
      padding: "16%", // スライダーの左右の余白
      gap: "5rem", // スライド間の余白
      pagination: false,
      breakpoints: {
        768: {
          gap: 0,
          padding: 0,
        }
      },
    }).mount();
  });
}


var detailsElements = document.querySelectorAll('.mh-hoverDetails');

detailsElements.forEach(function (detailsElement) {
  detailsElement.addEventListener('mouseenter', function () {
    detailsElement.setAttribute('open', true);
  });

  detailsElement.addEventListener('mouseleave', function () {
    detailsElement.removeAttribute('open');
  });
});